/* eslint-disable eqeqeq */
import { useState, useEffect } from 'react';
import {
  useOutletContext,
  useLocation,
  useParams,
  useNavigate,
} from 'react-router-dom';
import { useForm } from 'react-hook-form';
import {
  Button,
  Grid,
  Box,
  Typography,
  AccordionSummary,
  Accordion,
  AccordionDetails,
  Fade,
  CircularProgress,
  Container,
} from '@mui/material';
import Col from 'react-bootstrap/Col';
import Modal from '../../components/common/Modal';
import Transcoder from '../../components/modals/Transcoder';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import ArrowBackIosNewOutlined from '@mui/icons-material/ArrowBackIosNewOutlined';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import languages from '../../utils/languages';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ModalTitle from '../../components/modals/ModalTitle';
import { createCollection } from './Resources';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import {
  getVideoById,
  updateCollection,
  publishCollection,
  getCollectionById,
} from './Resources';
import DrawerMenu from './DrawerMenu';
import SeriesStep1 from './SeriesStep1';
import SeriesStep2 from './SeriesStep2';
import SeriesStep3 from './SeriesStep3';
import SeriesStep4 from './SeriesStep4';
import SeriesStep5 from './SeriesStep5';
import SeriesStep6 from './SeriesStep6';
import SeriesStep7 from './SeriesStep7';
import { useAppProviderStore } from 'store/appProviderCopyStore';
import {
  CRUD_STATES,
  PAGE_COLLECTION_VIDEO_LIST,
  PAGE_COLLECTION_RELATED_VIDEO_COLLECTION_LIST,
  PAGE_COLLECTION_VIDEO_COLLECTION_SUGGESTION,
} from 'constants/app';
import { adminAPI } from 'services/admin';
import { useGlobalStore } from 'store/globalStore';
import {
  useTableSelectedList,
  tableSelectedListUtility,
} from 'hooks/useTableSelectedList';
import { useNotification } from 'hooks/useNotification';

const steps = [
  {
    id: 1,
    label: '1. Adicionar vídeos a série',
    description: `Lista de videos que pertence a série`,
  },
  {
    id: 2,
    label: '2. Trailer da série (opcional)',
    description: 'Trailer',
  },
  {
    id: 3,
    label: '3. Informações da série',
    description: `Descrições, associações e thumbnails`,
  },
  {
    id: 4,
    label: '4. Elementos associados',
    description: `Associar conteúdo sugeridos/relacionados`,
  },
  {
    id: 5,
    label: '5. Contratos dos conteúdos',
    description: `Observações gerais de uso interno`,
  },
  {
    id: 6,
    label: '6. Resumo',
    description: `Resumo da publicação`,
  },
  {
    id: 7,
    label: '7. Publicação',
    description: ``,
  },
];

function SeriesSteps() {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const [auth, setAuth] = useOutletContext();
  const [expanded, setExpanded] = useState(false);
  const [text, setText] = useState('Ver Mais');
  const [viewFields, setViewFields] = useState(false);
  const [collectionResponse, setCollectionResponse] = useState({});
  const [Collection, setCollection] = useState([]);
  const [confirmDialogAction, setConfirmDialogAction] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });
  const [transcoderAproval, setTranscoderAproval] = useState({
    trailer: false,
  });
  const [openTitleModal, setOpenTitleModal] = useState(false);
  const { openNotification, closeAllNotifications } = useNotification();
  const {
    activeStep,
    setActiveStep,
    setOpenTranscoder,
    openTranscoder,
    trailerUploadProgress,
    legendaTrailerUploadProgress,
    audioTrailerUploadProgress,
    setCancelUpload,
    setTrailerUploaded,
  } = useAppProviderStore();
  const { uploadIsLoading, setRefreshData } = useGlobalStore();
  const [formValidation, setFormValidation] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const { showConfirmationButton } = useState(true);
  const { control, handleSubmit, register, reset, watch, setValue, getValues } =
    useForm({
      mode: 'onChange',
    });
  const visibility = watch('visibility');

  const pageCollectionVideoList = useTableSelectedList(
    PAGE_COLLECTION_VIDEO_LIST
  );
  const relatedVideoCollectionList = useTableSelectedList(
    PAGE_COLLECTION_RELATED_VIDEO_COLLECTION_LIST
  );

  const videoOrCollectionSuggestion = useTableSelectedList(
    PAGE_COLLECTION_VIDEO_COLLECTION_SUGGESTION
  );

  // reset on exit
  useEffect(() => {
    return () => {
      pageCollectionVideoList.reset();
      relatedVideoCollectionList.reset();
      videoOrCollectionSuggestion.reset();
      closeAllNotifications();
      setActiveStep(1);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const disableButton = useMemo(() => {
  //   if (["18", "A18"].includes(collectionResponse?.ageRating)
  //          ) {
  //     return true;
  //   }
  //   // return !collectionResponse?.targetAudiences?.some(a =>
  //   //   allowed.includes(a)
  //   // );
  // }, [collectionResponse?.ageRating]);

  const isOverEighteen = () => {
    if (visibility === 'EVERYONE') {
      return !!['18', 'A18'].includes(collectionResponse?.ageRating);
    } else {
      return false;
    }
  };

  const renderTitle = (step, index) => {
    if (activeStep === step.id) {
      return (
        <div className="unit_title_page2" key={index}>
          {step.label}
        </div>
      );
    }
  };
  const handleDeleteDraftCollection = async resolveByUserDelete => {
    setIsLoading(true);
    let id = getValues('id');
    let version = getValues('version');
    try {
      const path = `/admin/series/${id}/versions/${version}`;
      await adminAPI.del(path);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      const errorJson = error.request.response;
      const parseJson = JSON.parse(errorJson);
      openNotification({
        isOpen: true,
        message: parseJson.message,
        type: 'error',
        title: `Passo ${activeStep}: Erro ao excluir série.`,
      });
      console.log(error);
    }
  };

  const handleClose = async () => {
    if (!uploadIsLoading) {
      if (location?.state?.action === CRUD_STATES.VIEW) {
        setConfirmDialogAction({
          isOpen: false,
        });
        navigate('/series', { state: { refetch: Date.now() } });
        return;
      }
      if (location?.state?.action === CRUD_STATES.CREATE) {
        let id = getValues('id');
        if (id) {
          setConfirmDialogAction({
            isOpen: true,
            title: (
              <div className="modalTitleText">Deseja remover o cadastro?</div>
            ),
            subTitle: (
              <div className="modalBodyText">
                Essa ação exclui o cadastro permanentemente, deseja continuar?
              </div>
            ),
            children: (
              <div className="modalRemoveItem">
                <DeleteOutlineOutlinedIcon color="error" fontSize="12px" />
              </div>
            ),
            confirmTextButton: 'Sim, excluir',
            color: 'error',
            onConfirm: async () => {
              if (location?.state?.action === CRUD_STATES.CREATE) {
                setConfirmDialogAction({
                  isOpen: false,
                });
                await handleDeleteDraftCollection(true);
                if (uploadVerification()) {
                  setCancelUpload(true);
                }
                setTimeout(() => {
                  navigate('/series', { state: { refetch: Date.now() } });
                }, 4000);
              }
            },
            showConfirmationButton: { showConfirmationButton },
            confirmTextCloseButton: 'Não, salvar e sair.',
            showCancelWithAction: true,
            onConfirmAndClose: async () => {
              if (location?.state?.action === CRUD_STATES.CREATE) {
                if (uploadVerification()) {
                  setConfirmDialogAction({
                    isOpen: false,
                  });
                  openNotification({
                    isOpen: true,
                    message:
                      'Existem uploads em andamento, por favor, aguarde a finalização para poder sair.',
                    type: 'info',
                    title: 'Por favor, aguarde!',
                  });
                  return;
                } else {
                  await onSubmit();
                  setConfirmDialogAction({
                    isOpen: false,
                  });
                  setTimeout(() => {
                    navigate('/series', { state: { refetch: Date.now() } });
                  }, 4000);
                }
              }
            },
            closeTextButton: 'Não',
          });
        } else {
          navigate('/series', { state: { refetch: Date.now() } });
        }
      }
      if (location?.state?.action === CRUD_STATES.EDIT) {
        if (uploadVerification()) {
          setConfirmDialogAction({
            isOpen: false,
          });
          openNotification({
            isOpen: true,
            message:
              'Existem uploads em andamento, por favor, aguarde a finalização para poder sair.',
            type: 'info',
            title: 'Por favor, aguarde!',
          });
          return;
        } else {
          navigate('/series', { state: { refetch: Date.now() } });
        }
      }
    } else {
      openNotification({
        isOpen: true,
        message:
          'Existem uploads em andamento, por favor, aguarde a finalização para poder sair.',
        type: 'info',
        title: 'Por favor, aguarde!',
      });
    }
  };

  const handleSaveAndExit = async () => {
    if (!viewFields) {
      onSubmit();
      setTimeout(() => {
        navigate('/series', { state: { refetch: Date.now() } });
      }, 1000);
    }
  };

  const handleNextWithoutSave = async () => {
    if (activeStep < 7 && !isLoading) {
      setActiveStep(prevActiveStep => {
        return prevActiveStep + 1;
      });
    }
  };

  const handleNext = async () => {
    if (pageCollectionVideoList?.selectedItems?.length > 0) {
      if (location?.state?.action === CRUD_STATES.VIEW || viewFields) {
        if (activeStep < 7 && !isLoading) {
          setActiveStep(prevActiveStep => {
            return prevActiveStep + 1;
          });
        }
      } else {
        const response = onSubmit();
        if (response) {
          if (activeStep < 7 && !isLoading) {
            setActiveStep(prevActiveStep => {
              return prevActiveStep + 1;
            });
          }
        }
      }
    } else {
      openNotification({
        isOpen: true,
        message:
          'A série precisa ter ao menos 1 video associado, para avançar selecione os videos que compõe essa série.',
        type: 'info',
        title: 'Atenção.',
      });
    }
  };

  const handleOpen = async action => {
    setOpenTitleModal(true);
  };

  const uploadVerification = () => {
    let uploading = false;
    if (
      (trailerUploadProgress?.percent > 0 &&
        trailerUploadProgress?.percent < 100) ||
      (legendaTrailerUploadProgress?.percent > 0 &&
        legendaTrailerUploadProgress?.percent < 100)
    ) {
      uploading = true;
    }
    // console.log("trailerUploadProgress", trailerUploadProgress?.percent);
    return uploading;
  };

  const onSubmit = async () => {
    setIsLoading(true);
    const formValues = getValues();

    // eslint-disable-next-line sonarjs/no-unused-collection
    let launchingCountry = [];
    if (formValues?.launchingCountry?.length) {
      for (let country of formValues.launchingCountry) {
        launchingCountry.push({ countryId: country.countryId });
      }
    }

    let units = [];
    if (formValues?.units) {
      for (let unit of formValues.units) {
        units.push({ unitId: unit.value || unit.unitId });
      }
    }

    let channels = [];
    if (formValues?.channels) {
      for (let channel of formValues.channels) {
        channels.push({ channelId: channel?.value || channel.channelId });
      }
    }

    let personalities = [];
    if (formValues?.personalities) {
      for (let person of formValues.personalities) {
        personalities.push({
          personalityId: person.personalityId || person.value,
        });
      }
    }

    let personalitiesCredits = [];
    if (formValues?.personalitiesCredits) {
      for (let person of formValues.personalitiesCredits) {
        personalitiesCredits.push({
          personalityId: person.personalityId || person.value,
        });
      }
    }

    let responseToUpdate = {
      id: formValues?.id,
      version: formValues?.version,
      type: 'SERIE',
      comments: formValues?.comments,
      units: units,
      targetAudiences:
        formValues?.targetAudiences?.map(targetAudience => ({
          code: targetAudience,
        })) || [],
      ageRating: formValues?.ageRating,
      channels: channels,
      fullDescription: formValues?.fullDescription,
      keywords: formValues?.keywords,
      nextContentSuggestion: videoOrCollectionSuggestion.selectedItems?.[0]
        ? {
            contentId: videoOrCollectionSuggestion.selectedItems?.[0]?.id,
            contentType:
              videoOrCollectionSuggestion.selectedItems?.[0]?.type ||
              videoOrCollectionSuggestion.selectedItems?.[0]?.contentType,
          }
        : null,
      personalitiesCredits: personalitiesCredits,
      personalities: personalities,
      //relatedContents: relatedContents,
      relatedFiles: formValues?.relatedFiles,
      shortDescription: formValues?.shortDescription,
      //status: formValues?.status,
      technicalSheet: formValues?.technicalSheet,
      title: formValues?.title,
      trailerId: formValues?.trailerId || null,
      visibility: formValues?.visibility,
      videos: formValues?.videos,
    };

    if (!formValues?.thumbnails || formValues.thumbnails.length === 0) {
      delete responseToUpdate.thumbnails;
    }

    if (activeStep === 3) {
      onSubmitFormValidation();
    }
    try {
      let path = `/admin/series/${getValues('toId')}/versions/${getValues('toVersion')}`;
      let response = await updateCollection(
        path,
        auth,
        setAuth,
        openNotification,
        responseToUpdate,
        setIsLoading,
        tableSelectedListUtility.mapTableDataToRemote(
          relatedVideoCollectionList.selectedItems,
          ['contentId', 'contentType', 'createSortNumber']
        ),
        activeStep,
        getValues,
        tableSelectedListUtility.mapVideoCollectionFormat(
          pageCollectionVideoList.selectedItems
        ),
        params?.id,
        params?.version,
        Collection,
        setCollection
      );
      return !(response === 'Network Error');
    } catch (error) {
      return false;
    }
  };

  const handlePublish = async () => {
    if (uploadVerification()) {
      openNotification({
        isOpen: true,
        message:
          'Existem uploads em andamento, por favor, aguarde a finalização para poder publicar o conteúdo.',
        type: 'info',
        title: 'Por favor, aguarde!',
      });
    } else {
      if (
        (location?.state?.action === CRUD_STATES.EDIT ||
          location?.state?.action === CRUD_STATES.CREATE) &&
        activeStep === 7 &&
        !isLoading &&
        !viewFields
      ) {
        setOpenTranscoder(true);
        return;
      }
    }
  };

  const onSubmitFormValidation = async () => {
    setIsLoading(true);
    const formValues = getValues();

    const rawLaunchYear = formValues?.launchYear;
    const launchYearToSend =
      rawLaunchYear === null
        ? null
        : rawLaunchYear === undefined || rawLaunchYear === ''
          ? undefined
          : Number(rawLaunchYear);

    const launchingCountry = formValues?.launchingCountry?.length
      ? formValues.launchingCountry.map(c => ({ countryId: c.countryId }))
      : undefined;

    let units = [];
    if (formValues?.units) {
      for (let unit of formValues.units) {
        units.push({ unitId: unit.value || unit.unitId });
      }
    }

    let channels = [];
    if (formValues?.channels) {
      for (let channel of formValues.channels) {
        channels.push({ channelId: channel?.value || channel.channelId });
      }
    }

    let personalities = [];
    if (formValues?.personalities) {
      for (let person of formValues.personalities) {
        personalities.push({
          personalityId: person.personalityId || person.value,
        });
      }
    }

    let personalitiesCredits = [];
    if (formValues?.personalitiesCredits) {
      for (let person of formValues.personalitiesCredits) {
        personalitiesCredits.push({
          personalityId: person.personalityId || person.value,
        });
      }
    }

    let valuesToUpdate = {
      id: formValues?.id,
      version: formValues?.version,
      comments: formValues?.comments,
      channels: channels,
      fullDescription: formValues?.fullDescription,
      keywords: formValues?.keywords,
      nextContentSuggestion: videoOrCollectionSuggestion.selectedItems?.[0]
        ? {
            contentId: videoOrCollectionSuggestion.selectedItems?.[0]?.id,
            contentType:
              videoOrCollectionSuggestion.selectedItems?.[0]?.type ||
              videoOrCollectionSuggestion.selectedItems?.[0]?.contentType,
          }
        : null,
      personalities: personalities,
      personalitiesCredits: personalitiesCredits,
      ageRating: formValues?.ageRating,
      //relatedContents: relatedContents,
      relatedFiles: formValues?.relatedFiles,
      visibility: formValues?.visibility,
      launchingCountry: launchingCountry,
      launchYear: launchYearToSend,
      shortDescription: formValues?.shortDescription,
      //status: formValues?.status,
      technicalSheet: formValues?.technicalSheet,
      title: formValues?.title,
      trailerId: formValues?.trailerId,
      type: 'SERIE',
      units: units,
      targetAudiences:
        formValues?.targetAudiences?.map(targetAudience => ({
          code: targetAudience,
        })) || [],
      videos: formValues?.videos,
    };

    if (!formValues?.trailerId) {
      delete valuesToUpdate.trailerId;
    }

    if (!formValues?.nextContentSuggestion) {
      delete valuesToUpdate.nextContentSuggestion;
    }

    if (!formValues?.launchingCountry?.length) {
      delete valuesToUpdate.launchingCountry;
    }
    const filteredObj = Object.fromEntries(
      Object.entries(valuesToUpdate).filter(
        ([key, value]) =>
          key !== 'launchYear' &&
          (value === undefined ||
            value === null ||
            value.length === 0 ||
            value === '')
      )
    );

    //informacoes que não precisam ser validadas ainda
    delete filteredObj['nextContentSuggestion'];
    delete filteredObj['keywords'];
    delete filteredObj['personalities'];
    delete filteredObj['personalitiesCredits'];
    delete filteredObj['trailerId'];
    delete filteredObj['relatedContents'];
    delete filteredObj['comments'];
    delete filteredObj['relatedFiles'];
    delete filteredObj['technicalSheet'];
    delete filteredObj['videos'];
    delete filteredObj['launchYear'];

    if (valuesToUpdate.title != undefined && valuesToUpdate.title.length < 3) {
      filteredObj['title'] = '';
    }

    if (
      valuesToUpdate.shortDescription != undefined &&
      valuesToUpdate.shortDescription.length < 3
    ) {
      filteredObj['shortDescription'] = '';
    }

    if (valuesToUpdate.targetAudiences.length === 0) {
      filteredObj['targetAudiences'] = [];
    }

    if (
      valuesToUpdate.fullDescription != undefined &&
      valuesToUpdate.fullDescription.length < 3
    ) {
      filteredObj['fullDescription'] = '';
    }

    if (
      valuesToUpdate.thumbnails != undefined &&
      (valuesToUpdate.thumbnails[0] === undefined ||
        valuesToUpdate.thumbnails[1] === undefined)
    ) {
      filteredObj['thumbnails'] = '';
    }

    if (valuesToUpdate.units.length > 0 || valuesToUpdate.channels.length > 0) {
      delete filteredObj['units'];
      delete filteredObj['channels'];
    }

    if (!formValues.thumbnails) {
      filteredObj['thumbnails'] = '';
    }

    let keysArray = Object.keys(filteredObj);
    setFormValidation(keysArray);

    let path = `/admin/series/${getValues('toId')}/versions/${getValues('toVersion')}`;

    let response = await updateCollection(
      path,
      auth,
      setAuth,
      openNotification,
      //_.omitBy(valuesToUpdate, _.isNil),
      valuesToUpdate,
      setIsLoading,
      tableSelectedListUtility.mapTableDataToRemote(
        relatedVideoCollectionList.selectedItems,
        ['contentId', 'contentType', 'createSortNumber']
      ),
      activeStep,
      getValues,
      tableSelectedListUtility.mapVideoCollectionFormat(
        pageCollectionVideoList.selectedItems
      ),
      params?.id,
      params?.version,
      Collection,
      setCollection
    );

    if (activeStep === 5) {
      let path = `/${valuesToUpdate.id}/versions/${valuesToUpdate.version}`;
      let resp = await getCollectionById(path, auth, setAuth, openNotification);
      response = resp;
    }
    setCollectionResponse(response);

    return keysArray.length > 0 ? false : true;
  };

  const handleAccordionChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
    if (newExpanded) {
      setText('Ver Menos');
    } else {
      setText('Ver Mais');
    }
  };

  const handleBack = () => {
    if (activeStep > 1) {
      setActiveStep(prevActiveStep => {
        return prevActiveStep - 1;
      });
    }
  };

  // const findMaxAgeRating = (videos) => {
  //   // let videos = getValues('videos');
  //   let ratings = [];
  //   if (Array.isArray(videos)) {
  //     for (let video of videos) {
  //       if (video?.ageRating) {
  //         ratings.push(video?.ageRating);
  //       }
  //     }
  //     let filtered = [];
  //     for (let fill of ratings) {
  //       filtered.push(
  //         ageRatings.filter(function (el) {
  //           if (el?.acronym) {
  //             return el.acronym === fill;
  //           }
  //         })
  //       );
  //     }
  //     if (filtered.length > 0) {
  //       let ageRate = filtered.reduce((prev, current) =>
  //         prev && prev.priority > current.priority ? prev : current
  //       );
  //       return ageRate[0].acronym;
  //     }
  //     return "";
  //   }
  // };
  const verifyUpload = () => {
    if (
      trailerUploadProgress?.percent > 0 &&
      trailerUploadProgress?.percent < 100
    ) {
      return true;
    } else if (
      legendaTrailerUploadProgress?.percent > 0 &&
      legendaTrailerUploadProgress?.percent < 100
    ) {
      return true;
    } else if (
      audioTrailerUploadProgress?.percent > 0 &&
      audioTrailerUploadProgress?.percent < 100
    ) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    setValue('toId', params?.id);
    setValue('toVersion', params?.version);
  }, []);

  async function mountEditAndView() {
    setIsLoading(true);

    let path = `/${params?.id}/versions/${params?.version}`;
    const response = await getCollectionById(
      path,
      auth,
      setAuth,
      openNotification
    );

    if (response?.videos?.length > 0) {
      const video_path = `/${params?.id}/versions/${params?.version}/videos`;

      const responseVideo = await getVideoById(
        video_path,
        auth,
        setAuth,
        openNotification
      );

      // eslint-disable-next-line sonarjs/no-unused-collection
      let arrayData = [];
      responseVideo.videos.map(video => {
        arrayData.push({
          video: {
            videoId: video?.video?.videoId,
          },
          thumbnails: video?.video?.thumbnails,
          id: video?.video?.videoId,
          sortNumber: video?.sortNumber,
          nextSuggestionTimeSeconds: video?.nextSuggestionTimeSeconds,
          viewsLimit: video?.video?.viewsLimit,
          totalViews: video?.video?.totalViews,
          title: video?.video?.title,
          expiresIn: video?.video?.expiresIn,
          status: video?.video?.status,
          targetAudiences: video?.video?.targetAudiences,
          visibility: video?.video?.visibility,
          statusEdit: false,
        });
      });

      pageCollectionVideoList.setSelectedItems(
        tableSelectedListUtility.collectionMapRemoteDataToTable(arrayData)
      );

      setCollection(response);
    }

    // if (response?.videos?.length > 0) {
    //   const fetchVideoArray = response.videos.map(video => {
    //     const version = video?.version || 1;
    //     const video_path = `/admin/videos/${video?.video?.videoId}/versions/${version}`;
    //     return getVideoById(video_path, auth, setAuth, setNotify);
    //   });

    //   await Promise.all(fetchVideoArray).then(videosResponse => {
    //     setVideoToCollection(videosResponse);
    //   });
    // }

    let nextContentSuggestion = null;
    if (
      response?.nextContentSuggestion?.id ||
      response?.nextContentSuggestion?.contentId
    ) {
      const nextSuggestionToTableValue = {
        ...response?.nextContentSuggestion,
        id:
          response?.nextContentSuggestion?.contentId ||
          response?.nextContentSuggestion?.id,
      };

      videoOrCollectionSuggestion.setSelectedItems([
        nextSuggestionToTableValue,
      ]);

      nextContentSuggestion = {
        contentId:
          response?.nextContentSuggestion?.contentId ||
          response?.nextContentSuggestion?.id ||
          null,
        contentType:
          response?.nextContentSuggestion?.contentType ||
          response?.nextContentSuggestion?.type ||
          null,
      };
    }
    // setRelatedContents(response?.relatedContents);
    let valuesToUpdate = {
      channels: response?.channels
        ? response?.channels.map(channel => ({
            value: channel.channelId,
            label: channel.name,
            channelId: channel.channelId,
          }))
        : [],
      comments: response?.comments,
      fullDescription: response?.fullDescription,
      launchingCountry: response?.launchingCountry || [],
      launchYear: response?.launchYear,
      keywords: response?.keywords,
      id: response?.id,
      languageId: response?.languageId,
      nextContentSuggestion: nextContentSuggestion,
      personalities: response?.personalities
        ? response?.personalities.map(person => ({
            value: person.personalityId,
            label: person.name,
            personalityId: person.personalityId,
          }))
        : [],
      personalitiesCredits: response?.personalitiesCredits
        ? response?.personalitiesCredits.map(person => ({
            value: person.personalityId,
            label: person.name,
            personalityId: person.personalityId,
          }))
        : [],
      relatedContents: response?.relatedContents,
      relatedFiles: response?.relatedFiles,
      shortDescription: response?.shortDescription,
      status: response?.status,
      ageRating: response?.ageRating,
      thumbnails: response?.thumbnails,
      technicalSheet: response?.technicalSheet,
      title: response?.title,
      trailerId: response?.trailerId,
      type: response?.type,
      units: response?.units
        ? response?.units.map(unit => ({
            value: unit.unitId,
            label: unit.name,
          }))
        : [],
      targetAudiences:
        response?.targetAudiences?.map(targetAudience => targetAudience.code) ||
        [],
      version: response?.version,
      visibility: response?.visibility,
      videos: response?.videos,
    };
    reset(valuesToUpdate);
    setCollectionResponse(valuesToUpdate);
    setIsLoading(false);
  }

  useEffect(() => {
    if (params.action === 'CREATE') {
      navigate(`/series/${params?.id}/${params.version}`, {
        state: { action: CRUD_STATES.CREATE, replace: true },
      });
    }

    if (activeStep === 1) {
      let crudAction;

      if (params.action === 'CREATE') {
        crudAction = 'CREATE';
      } else {
        crudAction = location?.state?.action;
      }
      if (
        [CRUD_STATES.EDIT, CRUD_STATES.CREATE, CRUD_STATES.VIEW].includes(
          crudAction
        )
      ) {
        crudAction === CRUD_STATES.VIEW && setViewFields(true);
        mountEditAndView();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep]);

  const handleConfirmPublish = async () => {
    let formValidation = await onSubmitFormValidation();

    if (formValidation === true) {
      await publishCollection(
        getValues('id'),
        getValues('version'),
        auth,
        setIsLoading,
        setViewFields,
        openNotification
      );
      // if (activeStep < 7 && !isLoading && !notify.isOpen) {
      //   setActiveStep(prevActiveStep => {
      //     return prevActiveStep + 1;
      //   });
      // }
    }
  };

  const handler = () => {
    // window.removeEventListener("beforeunload", handlerOnBeforeUnload, {
    //   capture: true,
    // });
    setConfirmDialogAction({
      isOpen: true,
      title: <div className="modalTitleText">Deseja sair da página?</div>,
      subTitle: (
        <div className="modalBodyText">
          Existem uploads em andamento, ao sair, o progresso será perdido.
          Deseja continuar?
        </div>
      ),
      children: (
        <div className="modalRemoveItem">
          <WarningAmberIcon color="secondary" fontSize="12px" />
        </div>
      ),
      confirmTextButton: 'Confirmar',
      color: 'error',
      onConfirm: async () => {
        setIsLoading(true);
        setActiveStep(1);
        // setMainUploaded(false);
        setTrailerUploaded(false);
        let resp = await getCollectionById();
        if (resp?.status === 'DRAFT' && !viewFields) {
          if (uploadVerification()) {
            setCancelUpload(true);
          }
        }
        let open = 'isOpen';
        setConfirmDialogAction(prevSelectedOptions => ({
          ...prevSelectedOptions,
          [open]: false,
        }));
        setTimeout(() => {
          navigate('/series', { state: { refetch: Date.now() } });
          window.location.reload(true);
          setIsLoading(false);
        }, 3000);
      },
      showConfirmationButton: showConfirmationButton,
      closeTextButton: 'Cancelar',
    });
  };

  const handleExit = async () => {
    if (uploadVerification()) {
      handler();
    } else {
      setRefreshData();
      navigate('/series');
    }
  };

  return (
    <Container id="collection-steps">
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Col
          className="user_col user_col_1_margin_top"
          style={{
            background:
              'linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(0deg, #E7E7E7, #E7E7E7)',
            marginBottom: 16,
          }}>
          <Box className={isLoading ? 'isLoading' : ''}>
            <Fade
              in={isLoading}
              style={{
                transitionDelay: isLoading ? '800ms' : '0ms',
              }}
              unmountOnExit>
              <CircularProgress />
            </Fade>
          </Box>
          <div className="unit_title_page" style={{ backgroundColor: 'white' }}>
            <div className="unit_title_page1">
              <svg
                width="53"
                height="53"
                viewBox="0 0 53 53"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <rect
                  x="4.00391"
                  y="4.4082"
                  width="44"
                  height="44"
                  rx="11"
                  fill="#1361A4"
                  fillOpacity="0.15"
                />
                <g clipPath="url(#clip0_1413_7316)">
                  <path
                    d="M32.6289 19.4707C33.9277 19.4707 35.0039 20.5469 35.0039 21.8457V33.7207C35.0039 35.0566 33.9277 36.0957 32.6289 36.0957H18.3789C17.043 36.0957 16.0039 35.0566 16.0039 33.7207V21.8457C16.0039 20.5469 17.043 19.4707 18.3789 19.4707H32.6289ZM20.1602 34.3145V31.0488H17.7852V33.7207C17.7852 34.0547 18.0449 34.3145 18.3789 34.3145H20.1602ZM20.1602 29.2676V26.2988H17.7852V29.2676H20.1602ZM20.1602 24.5176V21.252H18.3789C18.0449 21.252 17.7852 21.5488 17.7852 21.8457V24.5176H20.1602ZM29.0664 34.3145V28.6738H21.9414V34.3145H29.0664ZM29.0664 26.8926V21.252H21.9414V26.8926H29.0664ZM33.2227 33.7207V31.0488H30.8477V34.3145H32.6289C32.9258 34.3145 33.2227 34.0547 33.2227 33.7207ZM33.2227 29.2676V26.2988H30.8477V29.2676H33.2227ZM33.2227 24.5176V21.8457C33.2227 21.5488 32.9258 21.252 32.6289 21.252H30.8477V24.5176H33.2227Z"
                    fill="#1361A4"
                  />
                </g>
                <rect
                  x="4.00391"
                  y="4.4082"
                  width="44"
                  height="44"
                  rx="11"
                  stroke="#1361A4"
                  strokeOpacity="0.08"
                  strokeWidth="8"
                />
                <defs>
                  <clipPath id="clip0_1413_7316">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                      transform="translate(16.0039 16.4082)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <span style={{ margin: '0 10px' }}>
                {location?.state?.action === CRUD_STATES.EDIT
                  ? 'Editar'
                  : location?.state?.action === CRUD_STATES.VIEW
                    ? 'Visualizar'
                    : 'Incluir'}{' '}
                série
              </span>
              <ArrowForwardIosIcon />
            </div>
            {steps.map((step, index) => renderTitle(step, index))}
          </div>
          <div
            className="user_button_page"
            style={{ backgroundColor: 'white' }}>
            <Button
              sx={{
                color: 'rgba(20, 98, 165, 1)',
                backgroundColor: 'transparent',
                '&:hover': {
                  background: 'transparent',
                },
                // boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
                textTransform: 'capitalize',
                fontSize: '22px',
                fontWeight: '600',
              }}
              variant="text"
              startIcon={<ArrowBackIosNewOutlined />}
              onClick={handleClose}
              id="collection-exit-button">
              Sair
            </Button>
          </div>
        </Col>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Col>
              <DrawerMenu
                steps={steps}
                setActiveStep={setActiveStep}
                activeStep={activeStep}
                getValues={getValues}
                onSubmit={onSubmit}
                videoToCollection={pageCollectionVideoList?.selectedItems}
                viewFields={viewFields}
              />
            </Col>
          </Grid>
          <Grid item xs={8}>
            {activeStep === 1 && (
              <Col style={{ background: 'transparent', marginBottom: 16 }}>
                <Box
                  className="info-container"
                  style={{ backgroundColor: 'rgba(227, 241, 255, 1)' }}>
                  <Accordion
                    expanded={expanded}
                    onChange={handleAccordionChange(true)}
                    style={{
                      backgroundColor: 'rgba(227, 241, 255, 1)',
                      padding: 14,
                      borderRadius: 12,
                    }}>
                    <AccordionSummary
                      aria-controls="acervod-content"
                      id="acervod-header">
                      <Typography
                        style={{
                          color: 'rgba(52, 64, 84, 1)',
                          fontWeight: 600,
                          fontSize: 14,
                        }}>
                        <svg
                          style={{ marginRight: 7 }}
                          width="39"
                          height="39"
                          viewBox="0 0 39 39"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <g opacity="0.3">
                            <rect
                              x="6.50391"
                              y="6.41211"
                              width="26"
                              height="26"
                              rx="5"
                              stroke="#475467"
                              strokeWidth="2"
                            />
                          </g>
                          <g opacity="0.1">
                            <rect
                              x="1.50391"
                              y="1.41211"
                              width="36"
                              height="36"
                              rx="7"
                              stroke="#475467"
                              strokeWidth="2"
                            />
                          </g>
                          <path
                            d="M19.5033 22.7453V19.4119M19.5033 16.0786H19.5116M27.8366 19.4119C27.8366 24.0143 24.1056 27.7453 19.5033 27.7453C14.9009 27.7453 11.1699 24.0143 11.1699 19.4119C11.1699 14.8096 14.9009 11.0786 19.5033 11.0786C24.1056 11.0786 27.8366 14.8096 27.8366 19.4119Z"
                            stroke="#475467"
                            strokeWidth="1.66667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        Primeiros passos para a publicação de um item no Acervo.
                      </Typography>
                      <Button
                        variant="text"
                        sx={{
                          color: 'rgba(65, 75, 178, 1)',
                          backgroundColor: 'transparent',
                          '&:hover': {
                            background: 'transparent',
                          },
                          textTransform: 'capitalize',
                          fontSize: '14px',
                          fontWeight: '600',
                        }}
                        id="collection-expand-info-first-step-button">
                        {text}
                      </Button>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <div className="info-container-content">
                          <p>
                            Para garantir que este item será cadastrado
                            corretamente no Acervo Sesc SP, por favor, analise
                            os pré-requisitos de publicação e cumprimento dos
                            Padrões e Políticas estabelecidos. Para publicar um
                            item, é importante ter:
                          </p>
                          <ul>
                            <li>
                              Arquivos no padrão de Qualidade Sesc, que podem
                              ser consultados no Manual de Publicação{' '}
                            </li>
                            <li>
                              Arquivos de contratos relativos ao item, para
                              declaração dos Direitos Autorais e definição de
                              permissão de acesso
                            </li>
                            <li>
                              Informações de Obra ou Registro, para
                              preenchimento das Informações Técnicas
                            </li>
                          </ul>
                          <p>
                            Ainda tem dúvidas? Veja nossas{' '}
                            <a
                              href="https://www.sescsp.org.br/politica-de-privacidade/"
                              rel="noreferrer"
                              target="_blank">
                              Políticas de privacidade
                            </a>
                            .
                          </p>
                        </div>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </Box>
              </Col>
            )}

            <Col
              style={{
                boxShadow: '0px 20px 24px -4px rgba(16, 24, 40, 0.08)',
              }}>
              {activeStep === 1 && (
                <SeriesStep1
                  setIsEdit={setIsEdit}
                  getValues={getValues}
                  setValue={setValue}
                  viewFields={viewFields}
                />
              )}
              {activeStep === 2 && (
                <SeriesStep2
                  getValues={getValues}
                  setValue={setValue}
                  register={register}
                  control={control}
                  collectionResponse={collectionResponse}
                  languages={languages}
                  viewFields={viewFields}
                />
              )}
              {activeStep === 3 && (
                <SeriesStep3
                  getValues={getValues}
                  setValue={setValue}
                  watch={watch}
                  register={register}
                  control={control}
                  collectionResponse={collectionResponse}
                  viewFields={viewFields}
                />
              )}
              {activeStep === 4 && <SeriesStep4 viewFields={viewFields} />}
              {activeStep === 5 && (
                <SeriesStep5
                  setValue={setValue}
                  control={control}
                  viewFields={viewFields}
                  collectionResponse={collectionResponse}
                />
              )}
              {activeStep === 6 && (
                <SeriesStep6
                  getValues={getValues}
                  setValue={setValue}
                  collectionResponse={collectionResponse}
                  setCollectionResponse={setCollectionResponse}
                  viewFields={viewFields}
                  formValidation={formValidation}
                />
              )}
              {activeStep === 7 && (
                <SeriesStep7
                  setValue={setValue}
                  formValidation={formValidation}
                  activeStep={activeStep}
                  viewFields={viewFields}
                  setCollectionResponse={setCollectionResponse}
                  getValues={getValues}
                  collectionResponse={collectionResponse}
                  isLoading={isLoading}
                />
              )}

              <div className="step-button-group mt-3 mb-3 p-3">
                {activeStep > 1 && (
                  <>
                    <Button
                      variant="outlined"
                      style={{
                        color: 'rgba(52, 64, 84, 1)',
                      }}
                      onClick={handleBack}
                      // disabled={true}
                      id="collection-return-button">
                      Voltar
                    </Button>
                  </>
                )}
                {activeStep === 7 && (
                  <>
                    <Button
                      id="collection-add-new-collection-button"
                      style={{
                        color: 'rgba(19, 97, 164, 1)',
                        backgroundColor: 'rgba(234, 237, 244, 1)',
                      }}
                      variant="outlined"
                      onClick={handleOpen}
                      // disabled={true}
                    >
                      <AddOutlinedIcon
                        style={{ fontSize: 16, color: 'rgb(19, 97, 164)' }}
                      />{' '}
                      Adicionar nova série
                    </Button>
                  </>
                )}
                <>
                  {!isEdit && !viewFields && (
                    <Button
                      variant="outlined"
                      style={{
                        color: 'rgba(52, 64, 84, 1)',
                      }}
                      onClick={handleClose}
                      disabled={viewFields}
                      id="collection-cancel-button">
                      Cancelar
                    </Button>
                  )}

                  {!viewFields && (
                    <Button
                      style={{
                        color: 'rgba(52, 64, 84, 1)',
                      }}
                      onClick={handleSaveAndExit}
                      variant="outlined"
                      disabled={viewFields}
                      id="collection-save-and-continue-button">
                      Salvar e continuar depois
                    </Button>
                  )}
                </>

                {activeStep !== 6 && activeStep !== 7 && activeStep > 1 && (
                  <>
                    <Button
                      variant="outlined"
                      onClick={handleNextWithoutSave}
                      style={{
                        color: 'rgba(52, 64, 84, 1)',
                      }}
                      disabled={viewFields || verifyUpload()}>
                      Pular
                    </Button>
                  </>
                )}

                {activeStep !== 7 && (
                  <>
                    <Button
                      style={{
                        color: 'rgba(255, 255, 255, 1)',
                      }}
                      variant="contained"
                      onClick={handleNext}
                      // disabled={true}
                      id="collection-salve-and-advance-button">
                      {!viewFields && 'Salvar e '}Avançar
                    </Button>
                  </>
                )}
                {activeStep === 7 && (
                  <Button
                    style={{
                      color: 'rgba(255, 255, 255, 1)',
                    }}
                    variant="contained"
                    //type="submit"
                    onClick={handlePublish}
                    disabled={viewFields || verifyUpload() || isOverEighteen()}
                    id="collection-publish-button">
                    Publicar
                  </Button>
                )}
                {activeStep === 7 && viewFields && (
                  <Button
                    style={{
                      color: 'rgba(255, 255, 255, 1)',
                      width: 145,
                    }}
                    variant="contained"
                    onClick={handleExit}
                    id="collection-ok-button">
                    Ok
                  </Button>
                )}
              </div>
            </Col>
          </Grid>
        </Grid>
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </form>

      <ModalTitle
        open={openTitleModal}
        createCollection={createCollection}
        onClose={() => setOpenTitleModal(false)}
        CRUD_STATES={CRUD_STATES}
        setAuth={setAuth}
        auth={auth}
        type={'collection'}
      />
      <Modal
        confirmDialogAction={confirmDialogAction}
        setConfirmDialogAction={setConfirmDialogAction}
      />
      <Transcoder
        openTranscoder={openTranscoder}
        handleConfirmPublish={handleConfirmPublish}
        setViewStepTwoFields={() => {}} //setViewStepTwoFields is not being used
        handleNextWithoutSave={handleNextWithoutSave}
        setTranscoderAproval={setTranscoderAproval}
        transcoderAproval={transcoderAproval}
        setOpenTranscoder={setOpenTranscoder}
      />
    </Container>
  );
}

export default SeriesSteps;
